import {
  Controller,
  type ControllerProps,
  useFormContext,
} from "react-hook-form";
import React from "react";

import type { FieldPath, FieldValues } from "react-hook-form";
import { Swiper, type SwiperProps } from "src/components/Swiper/Swiper.tsx";

export type SegmentedControlFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName;
  onValueChange?: (value: any, form: any) => void;
  mirrorState?: TName;
} & Omit<SwiperProps<any>, "value"> &
  Omit<ControllerProps<TFieldValues, TName>, "render">;

export const SegmentedControlField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: SegmentedControlFieldProps<TFieldValues, TName>,
) => {
  const {
    name,
    mirrorState,
    control,
    rules,
    shouldUnregister,
    defaultValue,
    disabled,
    options: optionsProp,
    onValueChange: onValueChangeProp,
    ...restProps
  } = props;

  const form = useFormContext();

  return (
    <Controller
      defaultValue={defaultValue}
      //  disabled={disabled}
      control={control}
      shouldUnregister={shouldUnregister}
      rules={rules}
      key={name}
      name={mirrorState ?? name}
      render={({ field: { value, onChange } }) => {
        return (
          <Swiper
            disabled={disabled}
            onChange={(value) => {
              onChange(value);
              onValueChangeProp?.(value, form);
            }}
            value={value}
            options={optionsProp}
            {...restProps}
          />
        );
      }}
    />
  );
};
